var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialLeftUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347,
    height: 202,
    viewBox: "0 0 347 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_1572",
    x: 0,
    y: 1.5,
    width: 27,
    height: 199,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rettangolo_479",
    x: 9,
    y: 0,
    width: 338,
    height: 202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_986",
    "data-name": "Raggruppa 986",
    transform: "translate(-1420 -1594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1420, 1594)",
    filter: "url(#Tracciato_1572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1572-2",
    "data-name": "Tracciato 1572",
    d: "M47,195.5V59.42L38,52l9-7.792V195.5Z",
    transform: "translate(-35 -13)",
    fill: "#6466f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1420, 1594)",
    filter: "url(#Rettangolo_479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_479-2",
    "data-name": "Rettangolo 479",
    width: 320,
    height: 184,
    rx: 9,
    transform: "translate(12)",
    fill: "#6466f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialLeftUp);
export default __webpack_public_path__ + "static/media/tutorial-left-up.35dc63217ca95ae726fcd4e12e89e43b.svg";
export { ForwardRef as ReactComponent };